@if (activeLanguage === 'en') {
  <p> {{'WarrentyParagraph.p1'|cxTranslate}}
    <br>
      <br>
        {{'WarrentyParagraph.p2'|cxTranslate}}
        <a [href]='latestDocUrl$ |async ' target='_blank' rel='noopener noreferrer'>
        {{'WarrentyParagraph.hyperlinkText'|cxTranslate}}</a>.
        <br> <br>
        {{'WarrentyParagraph.p3'|cxTranslate}}
      </p>
    }
    <!-- es_MX -->
    @if (activeLanguage === 'es_MX') {
      <p>Para enviar una solicitud de garantía, por favor rellena el siguiente formulario online. Usted recibirá las
        instrucciones necesarias para el retorno de las piezas después de la confirmación de su entrada haciendo clic en
      'enviar'.</p>
    }


    <!-- fr_CA -->
    @if (activeLanguage === 'fr_CA') {
      <p>Remplissez le formulaire suivant en ligne pour présenter une réclamation sous garantie Bendix. Un astérisque *
        désigne les champs obligatoires. Si vous avez d’autres questions, veuillez consulter le guide Processus de
        garantie
      en ligne Bendix. Merci.</p>
    }